export default {
  inputPlaceholder: {
    id: 'shopping_assistant_input_placeholder',
    defaultMessage: 'Ask me…',
  },
  sendMessage: {
    id: 'shopping_assistant_send_message_button',
    defaultMessage: 'Send message',
  },
  sendMessageErrorContent: {
    id: 'shopping_assistant_send_message_error',
    defaultMessage: 'Failed to send message. Please try again.',
  },
  loadChatError: {
    id: 'shopping_assistant_load_chat_error',
    defaultMessage: 'Failed to load the conversation.',
  },
  retryButton: {
    id: 'shopping_assistant_retry_button',
    defaultMessage: 'Retry',
  },
  emittedFromMe: {
    id: 'shopping_assistant_emitted_from_me_alternative_text',
    defaultMessage: 'I say:',
  },
  emittedFromAssistant: {
    id: 'shopping_assistant_emitted_from_assistant_alternative_text',
    defaultMessage: 'Assistant says:',
  },
  promptSuggestionsTitle: {
    id: 'shopping_assistant_prompt_suggestions_title',
    defaultMessage: 'Suggestions',
  },
  chatNotFound: {
    id: 'shopping_assistant_chat_not_found',
    defaultMessage: 'This conversation could not be found.',
  },
  newChatButton: {
    id: 'shopping_assistant_new_chat_button',
    defaultMessage: 'Create new conversation',
  },
  disclaimer: {
    id: 'shopping_assistant_disclaimer',
    defaultMessage:
      'Let’s find what you need. I’m powered by AI and I might make mistakes.',
  },
  addToCartError: {
    id: 'shopping_assistant_add_to_cart_error',
    defaultMessage: 'Failed to add the product to the cart. Please try again.',
  },
} as const
